export function resolveDialogEndpoint(hub, searchParams = new URLSearchParams(location.search)) {
  const dialogUrl = searchParams.get("dialog_url");
  const iceServers = hub.iceServers || hub.ice_servers;

  if (dialogUrl) {
    const url = new URL(dialogUrl);
    const turn = searchParams.get("dialog_turn") === "keep" ? hub.turn : null;

    return {
      host: url.hostname,
      port: url.port || (url.protocol === "wss:" ? "443" : "80"),
      turn,
      ...(iceServers ? { iceServers } : {}),
      serverUrl: dialogUrl,
      usingOverride: true
    };
  }

  const overrideHost = searchParams.get("dialog_host");
  const overridePort = searchParams.get("dialog_port");
  const host = overrideHost || hub.host;
  const port = overridePort || hub.port;
  const usingOverride = Boolean(overrideHost || overridePort);
  const turn = usingOverride && searchParams.get("dialog_turn") !== "keep" ? null : hub.turn;

  return {
    host,
    port,
    turn,
    ...(iceServers ? { iceServers } : {}),
    serverUrl: `wss://${host}:${port}`,
    usingOverride
  };
}
